import clsx from "clsx";
import React from "react";

interface AccordionSingleItemProps {
	id: string;
	children: React.ReactNode;
	title: string;
	isActive: boolean;
	onShow: React.MouseEventHandler<HTMLButtonElement>;
}

export function AccordionSingleItem({
	id,
	title,
	children,
	isActive,
	onShow,
}: AccordionSingleItemProps) {
	return (
		<div className={clsx("accordion-item", { expanded: isActive })}>
			<button
				type="button"
				className="btn accordion-toggle"
				id={id}
				aria-controls={`section-${id}`}
				aria-expanded={isActive}
				onClick={onShow}
			>
				<span>{title}</span>
			</button>

			<section
				className="accordion-content"
				id={`section-${id}`}
				aria-labelledby={id}
			>
				{children}
			</section>
		</div>
	);
}
